import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { Button } from './Button';
import { usePlatform } from '../contexts/PlatformContext';
import { formatAED } from '../utils/pack';
export function PackSummary() {
  const {
    packPills,
    packPrice
  } = usePlatform();
  const navigate = useNavigate();
  const empty = packPills.length === 0;
  return <aside className="rounded-2xl border border-[#9b8cf0]/40 bg-[#9b8cf0]/[0.05] p-6 lg:sticky lg:top-24" data-id="element-71" data-mp="kkruyai5gh9t">
      <p className="font-mono text-xs uppercase tracking-widest text-[#c4baff]" data-id="element-72" data-mp="phi9gteb34t4">Your 1-month pack</p>
      <p className="mt-3 text-4xl font-medium tracking-tight" data-id="element-73" data-mp="bia6dpf0vcjn">
        {formatAED(packPrice)}
        <span className="ml-1 text-sm font-normal text-muted-foreground" data-id="element-74" data-mp="fjlx5y9mu3tf">/ mo</span>
      </p>
      <p className="mt-1 text-sm text-muted-foreground" data-id="element-75" data-mp="2w87xpt7xs1n0">
        30 daily sachets · {packPills.length} {packPills.length === 1 ? 'supplement' : 'supplements'}
      </p>

      <ul className="mt-6 space-y-2 border-t border-white/10 pt-5" data-id="element-76" data-mp="14cbsv8csdsf">
        {empty && <li className="text-sm text-muted-foreground" data-id="element-77" data-mp="16fby837znav">Add at least one supplement to continue.</li>}
        {packPills.map(p => <li key={p.id} className="flex items-center gap-2.5 text-sm" data-id="element-78" data-mp="a5seegsxfbm3">
            <span className="size-2 rounded-full" style={{
          backgroundColor: p.color
        }} aria-hidden="true" data-id="element-79" data-mp="63ox3bjktcsw" />
            <span className="flex-1" data-id="element-80" data-mp="k36s48ngtmap">{p.name}</span>
            <span className="font-mono text-[11px] text-muted-foreground" data-id="element-81" data-mp="k1vpwd9o4mlp">{p.timing === 'Morning' ? 'AM' : 'PM'}</span>
          </li>)}
      </ul>

      <p className="mt-6 flex gap-2 text-xs text-muted-foreground" data-id="element-82" data-mp="tt006zoefja7">
        <ShieldCheck className="size-4 shrink-0 text-[#9b8cf0]" data-id="element-83" data-mp="tvckvkljk7qy" />
        A family-medicine doctor verifies every selection before it's packed.
      </p>

      <Button size="lg" className="mt-6 w-full bg-[#9b8cf0] text-[#0f1017] hover:bg-[#b0a4f5]" disabled={empty} onClick={() => navigate('/review')} data-id="element-84" data-mp="12uzjjymvyzgb">
        Review pack <ArrowRight className="size-4" data-id="element-85" data-mp="3rnw24qx9kzna" />
      </Button>
    </aside>;
}